import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import { NitroText, NitroPanel, NitroIcon } from "nitro-components";

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
`;

const Description = styled.div`
	margin: 10px;
`;

const OuterContainer = styled.div`
	margin-bottom: 40px;
`;

const variant = variantValue => {
	let variant = {};
	console.log(variantValue);
	switch (variantValue) {
		case "Overutilised":
			variant = {
				textVariant: "negative",
				iconVariant: "filled-solid-red-warning"
			};
			break;
		case "Underutilised":
			variant = {
				textVariant: "under",
				iconVariant: "filled-solid-yellow-warning"
			};
			break;
		default:
			variant = {
				textVariant: "",
				iconVariant: ""
			};
			break;
	}
	return variant;
};

const CardBlock = props => (
	<OuterContainer>
		<NitroPanel noMargin>
			<Container>
				<NitroText
					size={55}
					variant="base1"
				>{`${props.Label}%`}</NitroText>
				<Description>
					<NitroIcon
						size={22}
						variant={props.Variant}
						name={props.Icon}
						right={12}
					/>
					<NitroText
						size={2}
						bold
						variant={props.Variant}
					>
						{props.Description}
					</NitroText>
				</Description>
			</Container>
		</NitroPanel>
	</OuterContainer>
);

CardBlock.propTypes = {
	Label: PropTypes.string,
	Description: PropTypes.string,
	Variant: PropTypes.string,
	Icon: PropTypes.string
};

CardBlock.defaultProps = {
	// defaultProp: ''
};

export default CardBlock;



// WEBPACK FOOTER //
// ./src/components/vehicle/CardBlock.js